// extracted by mini-css-extract-plugin
export default {"tabletImg":"IR","desktopImg":"JR","mobileImg":"KR","backgroundImage":"LR","content":"MR","rtbLeft":"NR","rtbRight":"OR","imageContainer":"PR","rtbBox":"QR","line":"RR"};
    if(module.hot) {
      // 1726593107030
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  